import React, { useMemo } from "react";
import {CssBaseline, GlobalStyles, ThemeProvider} from "@mui/material";
import {SnackbarProvider} from "notistack";
import {BrowserRouter} from "react-router-dom";
import useCustomTheme from "./useCustomTheme";
import {LocalizationProvider} from "@mui/x-date-pickers";
import {AdapterDayjs} from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from 'dayjs';
import 'dayjs/locale/de.js';
import I18nProvider from "./I18nProvider.jsx";
import ConfirmationDialogProvider from "./ConfirmationDialogProvider.jsx";

const System = ({ basename, children, locale: providedLocale, theme: providedTheme }) => {
  const locale = providedLocale || 'de';
  const theme = providedTheme || useCustomTheme();
  dayjs.locale(locale);

  const globalStyles = useMemo(() => ({
    html: {
      fontSize: theme.typography.fontSize,
    },
    body: {
      backgroundColor: theme.palette.background.default,
      height: '100dvh',
      overflow: 'auto',
    },
    a: {
      color: theme.palette.primary.main,
      textDecoration: 'none',
      '&:hover': {
        textDecoration: 'underline',
      },
      '&:visited': {
        color: 'inherited',
      }
    }
  }), [theme]);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <GlobalStyles styles={globalStyles} />
      <I18nProvider locale={locale}>
        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="de">
          <SnackbarProvider anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}>
            <ConfirmationDialogProvider>
              <BrowserRouter basename={basename}>
                {children}
              </BrowserRouter>
            </ConfirmationDialogProvider>
          </SnackbarProvider>
        </LocalizationProvider>
      </I18nProvider>
    </ThemeProvider>
  );
};

export default System;
